// dbext:profile=staging_mcdo2019_be

// import TinyMCE
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/silver';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link' ;
import 'tinymce/plugins/lists';
import 'tinymce/plugins/code' ;

export default {
    init()
    {
        tinymce.init({
            selector : '.has-editor',
            menubar  : false,
            plugins  : [ 'paste', 'link', 'lists', 'code', ],
            toolbar  : 'bold italic link bullist numlist paste code',
            height   : 500,
        });
    },

    get_content( id )
    {
        return tinymce.get( id ).getContent();
    }

}

